import {HotkeyConfiguration} from '@accurate-player/accurate-player-plugins';
import HotkeyDialog from '@pluto/hotkey-dialog/HotkeyDialog';
import {curry} from 'ramda';
import React from 'react';
import {TimelineMarker} from 'VideoAudioQC/Timeline/TimelineTypes';
import AdOverlayOnFrame from './AdOverlayOnFrame/AdOverlayOnFrame';
import AdPlaceholder from './AdPlaceholder/AdPlaceholder';

import './AccuratePlayer.scss';

export interface VideoProps {
    videoContainerRef: (instance: HTMLDivElement | null) => void;
    adOnPlayingFrame?: TimelineMarker,
    setVideoRef: (node: HTMLVideoElement) => void;
    showAd?: boolean;
    showHotkeys: boolean;
    showSafeMargins: boolean;
    videoAspectRatio: number;
    hotkeys: HotkeyConfiguration[],
    togglePlay: () => void,
    closeHotkeys: () => void,
}

export const getAd = (showAd?: boolean) => {
    if (showAd)
        return <AdPlaceholder />;
    
    return null;
};

export const getHotkeyDialog = curry((hotkeys: HotkeyConfiguration[], showHotkeys: boolean, onClose: () => void) => {
    if (!showHotkeys)
        return null;
    
    return (
        <HotkeyDialog
            hotkeys={hotkeys}
            onClose={onClose}
        />
    );
});

export const adOverlayOnFrame = (adOnPlayingFrame?: TimelineMarker) => {
    if (adOnPlayingFrame)
        return <AdOverlayOnFrame />;
    
    return null;
};

export const getSafeMargin = (showSafeMargins: boolean) => {
    if (!showSafeMargins)
        return null;
    
    return (
        <div className="safe-margin" />
    );
};

export default function AccuratePlayer(props: VideoProps) {
    const {
        setVideoRef,
        adOnPlayingFrame,
        videoContainerRef,
        showAd,
        showHotkeys,
        showSafeMargins,
        hotkeys,
        togglePlay,
        closeHotkeys,
    } = props;
    
    const ad = getAd(showAd);
    const adOverlay = adOverlayOnFrame(adOnPlayingFrame);
    const safeMargin = getSafeMargin(showSafeMargins);
    const hotkeyDialog = getHotkeyDialog(hotkeys, showHotkeys, closeHotkeys);
    
    // crossOrigin="anonymous" to be able to mute/unmute audio stream using Web Audio API.
    return (
        <>
            <div
                aria-hidden="true"
                onClick={togglePlay}
                className="player-container"
            >
                {ad}
                <div
                    ref={videoContainerRef}
                    className="video-container"
                >
                    {adOverlay}
                    {safeMargin}
                    <video
                        className="video"
                        ref={setVideoRef}
                        crossOrigin="anonymous"
                        controlsList="nodownload"
                        disablePictureInPicture
                    />
                </div>
            </div>
            {hotkeyDialog}
        </>
    );
}
